function getHeaderAuthen() {
    const login = localStorage.getItem("auth");
    let config_token = {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${login}`,
        },
    };
    return config_token;
}

export default {
    getHeaderAuthen,
}